import React, { useState } from 'react';
import API_URL from '../../config';
import { getAuthTokenFromSession } from '../../utils/auth';

import avatar from '../../assets/avatar-default-svgrepo-com.svg';
import './Profile.css';

const Profile = ({ isProfileOpen, toggleModal, loadUser, user }) => {
  const initialUserInputState = {
    name: user.name,
    age: user.age,
    pet: user.pet,
  };

  const [userInput, setUserInput] = useState(initialUserInputState);

  const { name, age, pet } = userInput;

  const onFormChange = (event) => {
    switch (event.target.name) {
      case 'user-name':
        setUserInput({ ...userInput, name: event.target.value });
        break;
      case 'user-age':
        setUserInput({ ...userInput, age: event.target.value });
        break;
      case 'user-pet':
        setUserInput({ ...userInput, pet: event.target.value });
        break;
      default:
        return;
    }
  };

  const onProfileUpdate = (data) => {
    fetch(`${API_URL}/profile/${user.id}`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthTokenFromSession()}`,
      },
      body: JSON.stringify({ formInput: data }),
    })
      .then((resp) => {
        if (resp.status === 200 || resp.status === 304) {
          toggleModal();
          loadUser({ ...user, ...data });
        }
      })
      .catch(console.log);
  };

  return (
    <div className='profile-modal'>
      <article className='br3 ba b--black-10 mv4 w-100 w-50-m w-25-l mw6 shadow-5 center bg-white'>
        <main className='pa4 black-80 w-80'>
          <img src={avatar} className='h3 w3 dib' alt='avatar' />
          <h1>{userInput.name}</h1>
          <h4>{`Images Submitted: ${user.entries}`}</h4>
          <p>{`Member since: ${new Date(user.joined).toLocaleDateString()}`}</p>
          <hr />

          <label className='mt2 fw6' htmlFor='user-name'>
            Name:
          </label>
          <input
            onChange={onFormChange}
            className='pa2 ba w-100'
            placeholder={user.name}
            type='text'
            name='user-name'
            id='name'
          />
          <label className='mt2 fw6' htmlFor='user-age'>
            Age:
          </label>
          <input
            onChange={onFormChange}
            className='pa2 ba w-100'
            placeholder={user.age}
            type='text'
            name='user-age'
            id='age'
          />

          <label className='mt2 fw6' htmlFor='user-name'>
            Pet:
          </label>
          <input
            onChange={onFormChange}
            className='pa2 ba w-100'
            placeholder={user.pet}
            type='text'
            name='user-pet'
            id='pet'
          />
          <div
            className='mt4'
            style={{ display: 'flex', justifyContent: 'space-evenly' }}
          >
            <button
              onClick={() => onProfileUpdate({ name, age, pet })}
              className='b pa2 grow pointer hover-white w-40 bg-light-blue b--black-20'
            >
              Save
            </button>
            <button
              className='b pa2 grow pointer hover-white w-40 bg-light-red b--black-20'
              onClick={toggleModal}
            >
              Cancel
            </button>
          </div>
        </main>
        <div className='modal-close' onClick={toggleModal}>
          &times;
        </div>
      </article>
    </div>
  );
};

export default Profile;
